import React from 'react';
import ContractEnergyDTO from 'features/contracts/dtos/ContractEnergyDTO';
import ContractFullDTO from 'features/contracts/dtos/ContractFullDTO';
import PageCard from 'features/shared/components/card/PageCard';
import InfoItem from 'features/shared/components/infoItem/InfoItem';
import { formatDate } from 'features/shared/helpers/Formatters';
import { useTranslation } from 'react-i18next';
import { getTerminationDate } from 'features/shared/helpers/dateHelper';

type Props = {
  contract: ContractFullDTO;
  contractEnergy?: ContractEnergyDTO;
}

const ContractHeatBasicInfoCard = ({ contract, contractEnergy }: Props) => {
  // translations
  const { t } = useTranslation(["contracts\\enums\\contractStatus"]);
  const tLabels = useTranslation("contracts\\contracts").t;
  const tTerms = useTranslation("shared\\terms").t;

  // render
  return (
    <PageCard title={tLabels("contractHeatBasicInfoCard.cardTitle")} bodyClassName="pb-0">
      <div className="row no-gutters">
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractHeatBasicInfoCard.effectiveDate")} value={formatDate(contract.effectiveDate!)!} icon="calendar-check" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractHeatBasicInfoCard.terminationDate")} value={getTerminationDate(contract, tTerms)} icon="calendar-times" />
        </div>
        <div className="col-sm-12 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractHeatBasicInfoCard.state")} value={t(contract.contractStatus!)} icon="tag" />
        </div>
      </div>
    </PageCard>
  )
}

export default ContractHeatBasicInfoCard;